import { useState } from 'react';
import {
  Checkbox,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
} from '@mui/material';
import { Snapshot } from 'types';

import { useSnapshots } from 'features/snapshots/api/getSnapshots';
import { grey } from '@mui/material/colors';

interface Props {
  analyzerId: number;
  checkIfSnapshotSelected: (snapshot: Snapshot) => boolean;
  handleSnapshotChecked: (event: React.ChangeEvent<HTMLInputElement>) => void;
  enableCheckAll?: boolean;
  handleCheckAllSnapshots?: (checked: boolean) => void;
  disabled?: boolean;
  getFilterSnapshots: (snapshots: Snapshot[]) => () => Snapshot[];
}

const SnapshotList = ({
  analyzerId,
  checkIfSnapshotSelected,
  handleSnapshotChecked,
  enableCheckAll,
  handleCheckAllSnapshots,
  disabled,
  getFilterSnapshots,
}: Props) => {
  const [checkAllEnabled, setCheckAllEnabled] = useState<boolean>(false);
  const { data: snapshots } = useSnapshots({ analyzerId });

  const crosspolSnapshotIds = snapshots?.map(
    (snapshot) => snapshot.crosspol_snapshot_id
  );

  const snapshotsWithoutCrosspol = snapshots?.filter(
    (snapshot) => !crosspolSnapshotIds?.includes(snapshot.id)
  );

  const onCheckAllSnapshots = () => {
    const checkAllToggle = !checkAllEnabled;
    setCheckAllEnabled(checkAllToggle);
    if (handleCheckAllSnapshots) {
      handleCheckAllSnapshots(checkAllToggle);
    }
  };

  const filterSnapshots = getFilterSnapshots(snapshotsWithoutCrosspol || []);

  if (!snapshots || !snapshotsWithoutCrosspol || snapshots.length === 0)
    return (
      <Typography color={grey[500]} sx={{ p: '2rem' }}>
        No snapshots found.
      </Typography>
    );

  return (
    <>
      <List dense>
        {enableCheckAll && (
          <ListItem>
            <ListItemIcon>
              <Checkbox
                edge='start'
                name={'select-all'}
                onChange={onCheckAllSnapshots}
                checked={checkAllEnabled}
                disabled={disabled}
              />
            </ListItemIcon>
            <ListItemText>Select All</ListItemText>
          </ListItem>
        )}
        {filterSnapshots().map((snapshot) => (
          <ListItem key={snapshot.id}>
            <ListItemIcon>
              <Checkbox
                edge='start'
                name={snapshot.id.toString()}
                onChange={handleSnapshotChecked}
                checked={checkIfSnapshotSelected(snapshot)}
                disabled={disabled}
              />
            </ListItemIcon>
            <ListItemText>{snapshot.name}</ListItemText>
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default SnapshotList;
